import { SortKeyConditionOperator } from "../enums/common.enum";

export class DynamodbKeysRequestModel {
    PartitionKey: string = "";
    SortKey: string = "";
    constructor(partitionKey: string = "", sortKey: string = "") {
        this.PartitionKey = partitionKey;
        this.SortKey = sortKey;
    }
}

export class DynamodbSortKeyConditionRequestModel {
    PartitionKey: string = "";
    sortKeyCondition: SortKeyConditionModel = new SortKeyConditionModel();
}

export class SortKeyConditionModel {
    Operator: SortKeyConditionOperator = SortKeyConditionOperator.BeginsWith;
    SortKeyValue1: string = "";
    SortKeyValue2: string = ""; // Chỉ cần nếu dùng BETWEEN
}